<template>
  <div class="page-main">
    <div class="flex w-100">
      <b-filter-left
        ref="refLeftFilter"
        :init_filter_data="init_filter_data"
        :search_data="search_data"
        @success="updateLeftFilter"
      />
      <div class="flex-1 w-0">
        <div class="flex flex-y-center flex-x-between m-b-10">
          <div class="flex flex-y-center">
            <el-button type="success" size="mini" icon="el-icon-plus" @click="itemDoApply()"
              >新增采购申请单
            </el-button>
            <el-dropdown class="m-l-10">
              <el-button type="default" size="mini">
                批量操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="batchDelete">
                  <span class="c-red">删除</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-form class="flex flex-y-center m-l-10" @submit.native.prevent="resetLeftFilter">
              <span>申请日期:</span>
              <e-date-picker
                type="daterange"
                :value.sync="shen_gou_date"
                isShowFast
                @change="resetLeftFilter"
              />
              <span class="m-l-10">是否已打印:</span>
              <el-select
                v-model="is_print"
                size="mini"
                placeholder="全部"
                clearable
                style="width: 110px"
                @change="searchListData"
              >
                <el-option label="已打印" value="1" />
                <el-option label="未打印" value="0" />
              </el-select>
            </el-form>
          </div>
        </div>
        <!-- 表格 -->
        <vxe-grid
          ref="refTable"
          :show-footer="!!tableData.length"
          :loading="loading"
          :columns="tableColumn"
          :data="tableData"
          :height="this.$util.getViewHeight() - 36 - 148"
          :footer-method="footerMethod"
          :cell-class-name="cellClassName"
          @cell-dblclick="itemDbDo"
          @resizable-change="handleColumnResize"
          @keydown="tableKeydown"
          @current-change="tableCurrentChange"
        >
          <!-- slot_default -->
          <template #default_shen_gou_code="{ row }">
            <el-link type="primary" @click="itemDoApply(row.shen_gou_code)">
              {{ row.shen_gou_code }}
            </el-link>
          </template>
          <template #default_shen_gou_date="{ row }">
            {{ row.shen_gou_date.slice(0, 10) }}
          </template>
          <template #default_shen_qing_ren="{ row }">
            <div>{{ row.shen_qing_ren_name }}</div>
            <div v-if="row.shen_qing_bu_men_name" class="c-gray">
              ({{ row.shen_qing_bu_men_name }})
            </div>
          </template>
          <template #default_qi_wang_date="{ row }">
            {{ row.qi_wang_date.slice(0, 10) }}
          </template>
          <template #default_list_chan_pin_tu="{ row }">
            <e-upload-image
              v-if="row.list_chan_pin_tu"
              :list.sync="row.list_chan_pin_tu"
              disabled
            />
          </template>
          <template #default_shen_gou_amount="{ row }">
            <span class="c-orange">{{ row.shen_gou_amount }}</span>
          </template>
          <!-- 是否已打印-显示 -->
          <template #default_is_print="{ row }">
            <el-tag v-if="row.is_print" type="success" size="mini">已打印</el-tag>
            <el-tag v-else type="danger" size="mini">未打印</el-tag>
          </template>
          <template #default_operate="{ row }">
            <el-dropdown>
              <el-button type="default" size="mini">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <!-- v-if="row.isChuangJian || row.isFuZe" -->
                <el-dropdown-item @click.native="itemDoApply(row.shen_gou_code)">
                  <span class="c-blue">编辑</span>
                </el-dropdown-item>
                <el-dropdown-item @click.native="itemPrint(row.shen_gou_code)">
                  <span class="c-gray">打印</span>
                </el-dropdown-item>
                <!-- v-if="row.isChuangJian || row.isFuZe" -->
                <el-dropdown-item
                  v-if="isAdmin"
                  @click.native="
                    itemDelete({ ids: [row.shen_gou_bill_id], codes: [row.shen_gou_code] })
                  "
                >
                  <span class="c-red">删除</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>

          <!-- slot_pager -->
          <template #pager>
            <div></div>
            <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
          </template>
        </vxe-grid>
      </div>
    </div>

    <!-- 弹窗-新增采购申请单 -->
    <PopupApplyDo
      v-if="isShowPopupApplyDo"
      :show.sync="isShowPopupApplyDo"
      :code="activeCode"
      @success="updatePage"
    />
  </div>
</template>

<script>
export default {
  tableName: 'new_purchase_apply_page_list',
  components: {
    PopupApplyDo: () => import('../common/popup-do')
  },
  data() {
    return {
      // loading
      loading: true,

      // filter
      is_print: '',
      shen_gou_date: [],
      sortData: {
        shen_gou_code: 'desc',
        order_id: 'asc'
      },
      init_filter_data: {
        active_parent_key: '采购单号',
        active_search_type: '单据',
        hide_count_keys: [],
        api_url_parent: '/admin/gcvip/shengou3/leftFatherFilter3',
        api_url_child: '/admin/gcvip/shengou3/leftFilter3'
      },
      left_filter_data: {
        search_type: '单据',
        list: []
      },

      // table
      tableData: [],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        shen_gou_counts_all: '',
        shen_gou_amount_all: ''
      },

      // popup
      isShowPopupApplyDo: false,
      activeBillId: null,
      activeCode: null
    }
  },
  computed: {
    // 搜索参数
    search_data() {
      let result = {
        shen_gou_date: this.shen_gou_date || []
      }
      return result
    },
    // 是否是管理员
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    },
    // 当前登录账号id
    accountId() {
      return this.$store.state.loginAccount.id
    },
    // 表格列
    tableColumn() {
      let result = [
        {
          fixed: 'left',
          type: 'checkbox',
          width: 40
        },
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          fixed: 'left',
          title: '采购申请单号',
          field: 'shen_gou_code',
          slots: { default: 'default_shen_gou_code' },
          width: 110
        },
        {
          title: '采购类型',
          field: 'shen_gou_type'
        },
        {
          title: '申请日期',
          field: 'shen_gou_date',
          slots: { default: 'default_shen_gou_date' }
        },
        {
          title: '申请人',
          field: 'shen_qing_ren',
          slots: { default: 'default_shen_qing_ren' }
        },
        {
          title: '期望交期',
          field: 'qi_wang_date',
          slots: { default: 'default_qi_wang_date' }
        },
        {
          title: '销售单号',
          field: 'bill_code'
        },
        {
          title: '供应商',
          field: 'supplier_name'
        },
        {
          title: '供应商负责人',
          field: 'supplier_fu_ze_ren'
        },
        {
          title: '供应商电话',
          field: 'supplier_phone'
        },
        {
          title: '物料图片',
          field: 'list_chan_pin_tu',
          slots: { default: 'default_list_chan_pin_tu' },
          width: 63
        },
        {
          title: '物料名称',
          field: 'name'
        },
        {
          title: '物料类型',
          field: 'wu_liao_type'
        },
        {
          title: '规格(mm)',
          field: 'spec'
        },
        {
          title: '单位',
          field: 'unit'
        },
        {
          title: '本次申购数量',
          field: 'shen_gou_counts'
        },
        {
          title: '单价(元)',
          field: 'goods_price'
        },
        {
          title: '金额(元)',
          field: 'shen_gou_amount',
          slots: { default: 'default_shen_gou_amount' }
        },
        {
          title: `备注`,
          field: 'remark',
          width: 160
        },
        {
          fixed: 'right',
          title: '是否已打印',
          field: 'is_print',
          width: 100,
          slots: { default: 'default_is_print' }
        },
        {
          fixed: 'right',
          title: '操作',
          field: 'operate',
          slots: { default: 'default_operate' },
          width: 73
        }
      ]
      this.$util.initTableColumnWidth(this.$options.tableName, result, 'inherit')
      return result
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    // 列宽变化，保存单列宽度
    handleColumnResize({ column }) {
      this.$util.setTableColumnWidth(this.$options.tableName, column.field, column.resizeWidth)
    },
    // 更新页面
    updatePage() {
      this.$refs.refLeftFilter.updateFilterGroupData()
      this.searchListData()
    },
    // 重置左侧筛选
    resetLeftFilter() {
      if (!this.left_filter_data.list.length) {
        let result = {
          search_type: this.init_filter_data.active_search_type,
          list: []
        }
        this.updateLeftFilter(result)
      }
    },
    // 更新左侧筛选
    updateLeftFilter(val) {
      this.left_filter_data = this.$util.deepCopy(val)
      this.searchListData()
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      let params = {
        currentPage: this.pageOptions.currentPage,
        pageSize: this.pageOptions.pageSize,
        shen_gou_date: this.search_data.shen_gou_date,
        is_print: this.is_print,
        sortData: this.$util.deepCopy(this.sortData)
      }
      if (this.left_filter_data.list.length) params.left_filter = this.left_filter_data.list

      this.$api({
        method: 'post',
        url: '/admin/gcvip/shengou3/list',
        data: params
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            let list = this.$util.deepCopy(data.list)
            list.forEach((item) => {
              item.isYinYong = this.isAdmin || item.saler_id === this.accountId
              item.isChuangJian = this.isAdmin || item.saler_id === this.accountId
              item.isFuZe = this.isAdmin || item.fu_ze_ren_id === this.accountId
            })
            this.tableData = list

            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber

            this.totalObj.shen_gou_counts_all = res.data.shen_gou_counts_all
            this.totalObj.shen_gou_amount_all = res.data.shen_gou_amount_all
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 获取-当前单选行
    getCheckboxRecords() {
      return this.$refs.refTable.getCheckboxRecords()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setCheckboxRow(params.row, true) // 选中checkbox
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowCheckbox = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isCurrentRowCheckbox) // 选中checkbox
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 表格底部
    footerMethod({ columns }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (column.field === 'shen_gou_counts') return this.totalObj.shen_gou_counts_all
          if (column.field === 'shen_gou_amount') return this.totalObj.shen_gou_amount_all
        })
      ]
    },
    // 行类名计算，实现按字段分组的斑马纹效果
    cellClassName(rowData) {
      let result = this.$tool.getTableCellClassName(this.tableData, rowData, 'shen_gou_code')
      return result
    },
    // 项-增改-采购申请
    itemDoApply(code = null) {
      this.activeCode = code
      this.isShowPopupApplyDo = true
    },
    // 项-双击增改
    itemDbDo(val) {
      this.itemDoApply(val.row.shen_gou_code)
    },
    // 项-打印
    itemPrint(code) {
      window.open(`/new/purchase/apply/print?code=${code}`, '_blank')
    },
    // 批量-删除
    batchDelete() {
      let rows = this.getCheckboxRecords()
      if (rows.length) {
        let ids = rows.map((item) => item.shen_gou_bill_id)
        let codes = rows.map((item) => item.shen_gou_code)

        let obj = {
          ids: [...new Set(ids)],
          codes: [...new Set(codes)]
        }
        this.itemDelete(obj)
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-删除
    itemDelete(obj) {
      this.$confirm(`您确定要删除编码为"${obj.codes.join(',')}"的采购申请单吗?`, '提示')
        .then(() => {
          this.deleteConfirm(obj.ids)
        })
        .catch(() => {})
    },
    // 项-删除-确认
    deleteConfirm(ids) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/shengou3/delete',
        params: {
          ids: ids.join(',')
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success('操作成功')
            this.getListData()
          }
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
</style>
